// Decision (locked, 2026-10-23): the UI offers only these two languages. The
// backend keeps every entry in config/initializers/languages.rb because
// Account.locale is an enum indexed by that hash — data already stored with a
// legacy locale (e.g. 'pt', 'es') must keep resolving. The restriction lives
// in the pickers, which all consume window.chatwootConfig.enabledLanguages.
export const SUPPORTED_LANGUAGE_CODES = ['pt_BR', 'en'];

export const filterSupportedLanguages = (languages = []) =>
  (languages || []).filter(language =>
    SUPPORTED_LANGUAGE_CODES.includes(language?.iso_639_1_code)
  );
